var _defs, _path, _circle, _path2, _path3, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0d71ba;}.cls-2{fill:#c13685;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,29A14,14,0,1,0,1,15,14,14,0,0,0,15,29"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15,
    cy: 15,
    r: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15,9c1.95,0,2.18,0,2.95,0a4,4,0,0,1,1.35.25,2.41,2.41,0,0,1,1.38,1.38,4,4,0,0,1,.25,1.35c0,.77,0,1,0,2.95s0,2.18,0,2.95a4,4,0,0,1-.25,1.35,2.41,2.41,0,0,1-1.38,1.38,4,4,0,0,1-1.35.25c-.77,0-1,0-2.95,0s-2.18,0-2.95,0a4,4,0,0,1-1.35-.25A2.41,2.41,0,0,1,9.32,19.3a4,4,0,0,1-.25-1.35c0-.77,0-1,0-2.95s0-2.18,0-2.95a4,4,0,0,1,.25-1.35A2.41,2.41,0,0,1,10.7,9.32a4,4,0,0,1,1.35-.25c.77,0,1,0,2.95,0m0-1.31c-2,0-2.23,0-3,0a5.35,5.35,0,0,0-1.77.34,3.73,3.73,0,0,0-2.13,2.13A5.35,5.35,0,0,0,7.76,12c0,.78,0,1,0,3s0,2.23,0,3a5.35,5.35,0,0,0,.34,1.77,3.73,3.73,0,0,0,2.13,2.13,5.35,5.35,0,0,0,1.77.34c.78,0,1,0,3,0s2.23,0,3,0a5.35,5.35,0,0,0,1.77-.34,3.73,3.73,0,0,0,2.13-2.13A5.35,5.35,0,0,0,22.24,18c0-.78,0-1,0-3s0-2.23,0-3a5.35,5.35,0,0,0-.34-1.77,3.73,3.73,0,0,0-2.13-2.13A5.35,5.35,0,0,0,18,7.76c-.78,0-1,0-3,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15,11.26A3.74,3.74,0,1,0,18.74,15,3.74,3.74,0,0,0,15,11.26Zm0,6.17A2.43,2.43,0,1,1,17.43,15,2.43,2.43,0,0,1,15,17.43Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18.89,
    cy: 11.11,
    r: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconInstagram);
export default __webpack_public_path__ + "static/media/social-icon-instagram.7a33804278237bd76776ef9a797989f3.svg";
export { ForwardRef as ReactComponent };